import { render, staticRenderFns } from "./ButtonMovie.vue?vue&type=template&id=a72885ea&scoped=true&"
import script from "./ButtonMovie.vue?vue&type=script&lang=ts&"
export * from "./ButtonMovie.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonMovie.vue?vue&type=style&index=0&id=a72885ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a72885ea",
  null
  
)

export default component.exports